import { FunctionComponent } from 'react';
import { Layout } from '@shopify/polaris';
import { AnnotatedSectionProps } from '@shopify/polaris/build/ts/latest/src/components/Layout/components/AnnotatedSection/AnnotatedSection';
import { StyledElement } from '@ui/types';
import { Container } from '../common';

export interface AnnotatedContainerProps extends StyledElement {
  annotated: AnnotatedSectionProps;
}

const Annotated: FunctionComponent<AnnotatedContainerProps> = ({
  annotated,
  children,
  className,
}) => (
  <Container className={className}>
    <Layout>
      <Layout.Section>
        <Layout.AnnotatedSection {...annotated}>
          {children}
        </Layout.AnnotatedSection>
      </Layout.Section>
    </Layout>
  </Container>
);

export default Annotated;
